<template>
  <div class="sidebar">
    <!-- Perfil de Usuario -->
    <div class="user-profile text-center mb-4">
      <img
        :src="fotoPerfil || 'https://i.pinimg.com/236x/cd/b7/bd/cdb7bd75c577b47b1c9224e4908e4372.jpg'"
        alt="Usuario"
        class="rounded-circle mb-2"
      />
      <h5>{{ nombreUsuario }}</h5>
      <small class="editar-perfil" @click="goToEditarPerfil">Editar perfil</small>
    </div>

    <!-- Menú -->
    <ul class="nav flex-column">
      <li class="nav-item" @click="goToDashboard">
        <a class="nav-link"><i class="fas fa-chart-line me-2"></i> Dashboard</a>
      </li>
      <li class="nav-item" @click="goToProspectos">
        <a class="nav-link"><i class="fas fa-user-plus me-2"></i> Prospectos</a>
      </li>
      <li class="nav-item" @click="goToClientes">
        <a class="nav-link"><i class="fas fa-users me-2"></i> Clientes</a>
      </li>
      <li class="nav-item" @click="goToBlog">
        <a class="nav-link"><i class="fas fa-blog me-2"></i> Blog</a>
      </li>
      <li class="nav-item" @click="goToCitas">
        <a class="nav-link"><i class="fas fa-calendar-check me-2"></i> Citas</a>
      </li>
      <li class="nav-item" @click="goToAdmins">
        <a class="nav-link"><i class="fas fa-user-shield me-2"></i> Administradores</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { EventBus } from '@/eventBus.js';

export default {
  name: 'Sidebar',
  data() {
    return {
      nombreUsuario: 'Usuario',
      fotoPerfil: null,
    };
  },
  mounted() {
    // Cargar perfil cuando se monta el componente
    this.cargarPerfil();

    // Escuchar evento para actualización inmediata
    EventBus.$on('perfilActualizado', () => {
      this.cargarPerfil();
    });

    // Recargar perfil cada vez que se navega a una nueva ruta
    this.$router.afterEach(() => {
      this.cargarPerfil();
    });
  },
  methods: {
    async cargarPerfil() {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const response = await fetch('http://localhost:3000/api/administradores/perfil', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Error al cargar perfil');

        const data = await response.json();

        this.nombreUsuario = data.nombre_completo || 'Usuario';
        this.fotoPerfil = data.foto_perfil
          ? `http://localhost:3000/uploads/${data.foto_perfil}`
          : null;
      } catch (error) {
        console.error('Error al cargar perfil:', error);
      }
      
    },
    goToDashboard() {
      this.$router.push('/dashboard');
    },
    goToProspectos() {
      this.$router.push('/listado_prospectos');
    },
    goToClientes() {
      this.$router.push('/clientes');
    },
    goToBlog() {
      this.$router.push('/admin/blogs/create');
    },
    goToCitas() {
      this.$router.push('/citas');
    },
    goToAdmins() {
      this.$router.push('/administradores');
    },
    goToEditarPerfil() {
      this.$router.push('/editar_perfil');
    },
  },
};
</script>

<style scoped>
.sidebar {
  background: linear-gradient(180deg, #35304d, #0a1e3b);
  color: white;
  width: 260px;
  height: 100vh;
  position: fixed;
  padding: 25px 20px;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.5);
  overflow-y: auto;
}

.user-profile img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border: 2px solid white;
}

.user-profile h5 {
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
}

.editar-perfil {
  display: block;
  font-size: 0.85rem;
  color: #a0a0a0;
  cursor: pointer;
  margin-top: 5px;
  text-decoration: underline;
}

.editar-perfil:hover {
  color: #ffffff;
}

.nav-link {
  color: white;
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  padding: 12px 10px;
  transition: background 0.3s ease;
  cursor: pointer;
}

.nav-link i {
  font-size: 1.2rem;
}

.nav-link:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
}
</style>
